import generateAdjustedEventTraits from 'src/js/modules/element-settings/helpers/generate-adjusted-event-traits';
import generateChangedOptionsTraits from 'src/js/modules/element-settings/helpers/generate-changed-options-traits';
import filterStateByBreakpointKey from 'src/js/modules/element-settings/helpers/filter-state-by-breakpoint-key';
import { SubmitTraitsGenerationContract } from 'src/js/modules/element-settings/helpers/stage-contracts';
import { breakpointKeys } from 'src/js/modules/element-settings/constants/breakpoints';
import appearanceAttributes from '../constants/appearance-attributes';

const getTraitName = (target) => {
  switch (target) {
    case appearanceAttributes.BORDER: {
      return 'Border';
    }

    case appearanceAttributes.SHADOW: {
      return 'Shadow';
    }

    case appearanceAttributes.BORDER_TOP_LEFT_RADIUS:
    case appearanceAttributes.BORDER_TOP_RIGHT_RADIUS:
    case appearanceAttributes.BORDER_BOTTOM_LEFT_RADIUS:
    case appearanceAttributes.BORDER_BOTTOM_RIGHT_RADIUS: {
      return 'Corners';
    }

    default: {
      return target;
    }
  }
};

const getAdjustedTraitsForBreakpoint = ({ prefix, stateByBreakpoint }) =>
  Object.values(stateByBreakpoint).reduce(
    (acc, targets) =>
      Object.keys(targets).reduce((targetsAcc, target) => {
        const adjustedTraits = generateAdjustedEventTraits(prefix, getTraitName(target), true);

        return {
          ...targetsAcc,
          ...adjustedTraits,
        };
      }, acc),
    {}
  );

const createSubmitTraitsMediaAppearanceHandler =
  ({ prefix }) =>
  (flowData, context) => {
    const { chunkStateDifference = {} } = context;

    const desktopTraits = getAdjustedTraitsForBreakpoint({
      prefix,
      stateByBreakpoint: filterStateByBreakpointKey(chunkStateDifference, breakpointKeys.DEFAULT),
    });
    const tabletTraits = getAdjustedTraitsForBreakpoint({
      prefix,
      stateByBreakpoint: filterStateByBreakpointKey(chunkStateDifference, breakpointKeys.MAX_XL),
    });
    const mobileTraits = getAdjustedTraitsForBreakpoint({
      prefix,
      stateByBreakpoint: filterStateByBreakpointKey(chunkStateDifference, breakpointKeys.MAX_MD),
    });

    const changedOptions = generateChangedOptionsTraits({
      desktopTraits,
      tabletTraits,
      mobileTraits,
    });

    return SubmitTraitsGenerationContract.create(changedOptions);
  };

export default createSubmitTraitsMediaAppearanceHandler;
